module.exports = __webpack_public_path__ + "img/edge_restauration_glace.5a9283a0.svg";